<template>
    <div v-if="isShow" class="modal feedSuccess_modal in" style="display: block;">
        <div class="modal-dialog" style="width: 300px;">
            <div class="modal-content">
                <div class="common-modal-close" @click="close">
                    <img src="../../assets/modal-close.png">
                </div>
                <div class="modal-body">
                    <img src="../../assets/ok.png">
                    <div class="text" v-html="text"></div>
                    <div class="know_btn" @click="close">我知道了</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SuggestionSubSuccess',
        props: {
            text: {
                type: String,
                default: '',
            }
        },
        data () {
            return {
                isShow: false,
                html: '',
            }
        },
        watch: {
            text (newVal) {
                this.html = newVal
            }
        },
        methods: {
            show () {
                this.isShow = true
            },
            close () {
                this.isShow = false
            }
        }
    }
</script>

<style scoped>
    .feedSuccess_modal{
        background-color: rgba(0,0,0,0.8);
    }
    .suggestion_form_modal .modal-body .logo {
        margin-right: 5px;
    }

    /*意见反馈成功*/
    .feedSuccess_modal .modal-body {
        padding: 8% 0;
        text-align: center;
        font-size: 16px;
    }

    .feedSuccess_modal .modal-body .text {
        padding: 16px 50px;
        color: #282b2c;
        font-weight: 400;
        line-height: 24px;
    }
    .feedSuccess_modal .modal-body .text p{
        margin-bottom: 4px;
        font-weight: 400;
    }

    .feedSuccess_modal .modal-body .know_btn {
        color: #006ab9;
        cursor: pointer;
    }

</style>
